var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Box, Button, IconButton, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import GridComp from '../grid';
import { MODOS, MENSAGENS, getDataFormatada } from '../../utils';
import { useAuth } from '../../contexts/auth/AuthContext';
import { BoxBotoes } from '../form_box';
import Loading from '../loading';
import { useParams } from 'react-router-dom';
import { BotaoFechar, BotaoAuxiliar } from '../botoes';
import { InputDados } from '../input_dados';
import { VisibilityOutlined as VisibilityOutlinedIcon, ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon, Download as DownloadIcon, } from '@mui/icons-material';
import { extrairBytesPdf, isPdfValido } from '../../pages/contratos_convenios/instituicoes_alterar/instituicoes_documentos/arquivo_pdf.utils';
export var DocumentosAnexosBaseForm = function (_a) {
    var pagina = _a.pagina, rotaVoltar = _a.rotaVoltar, services = _a.services, tipoIdField = _a.tipoIdField, listaDocumentosField = _a.listaDocumentosField, titulo = _a.titulo, abaVoltar = _a.abaVoltar, setAbaAtiva = _a.setAbaAtiva, fluxoCadastro = _a.fluxoCadastro;
    var _b = useAuth(), addMensagem = _b.addMensagem, getAcoesFuncionalidade = _b.getAcoesFuncionalidade;
    var acoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(pagina); }, [getAcoesFuncionalidade, pagina]);
    var _c = useParams(), id = _c.id, modo = _c.modo;
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState([]), documentos = _e[0], setDocumentos = _e[1];
    var _f = useState([]), tiposDisponiveis = _f[0], setTiposDisponiveis = _f[1];
    var _g = useState(''), nomeArquivo = _g[0], setNomeArquivo = _g[1];
    var _h = useState(''), nomeArquivoOriginal = _h[0], setNomeArquivoOriginal = _h[1];
    var _j = useState(null), arquivoSelecionado = _j[0], setArquivoSelecionado = _j[1];
    var _k = useState(-1), tipoSelecionado = _k[0], setTipoSelecionado = _k[1];
    var _l = useState(false), popupAberto = _l[0], setPopupAberto = _l[1];
    var _m = useState({ id: undefined, nome: '', tipoId: -1, nomeOriginal: '' }), editarDados = _m[0], setEditarDados = _m[1];
    var desabilitarCampos = modo === MODOS.VISUALIZAR || modo === MODOS.EXCLUIR;
    var carregarDados = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, tiposResp, itensResp, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!id)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, Promise.all([services.getTipos(), services.getItens(id)])];
                case 2:
                    _a = _c.sent(), tiposResp = _a[0], itensResp = _a[1];
                    setTiposDisponiveis(Array.isArray(tiposResp) ? tiposResp : tiposResp.dados || []);
                    setDocumentos(itensResp[listaDocumentosField] || ((_b = itensResp.dados) === null || _b === void 0 ? void 0 : _b[listaDocumentosField]) || []);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    console.error(error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [id, services, listaDocumentosField]);
    useEffect(function () {
        carregarDados();
    }, [carregarDados]);
    var handleFileChange = function (event) {
        var _a, _b, _c;
        var file = (_b = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
        if (!file)
            return;
        if (((_c = file.name.split('.').pop()) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== 'pdf') {
            alert('Selecione um arquivo do tipo PDF');
            return;
        }
        setArquivoSelecionado(file);
        setNomeArquivoOriginal(file.name);
    };
    var adicionarDocumento = function () { return __awaiter(void 0, void 0, void 0, function () {
        var formData, resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!nomeArquivo || tipoSelecionado === -1 || !arquivoSelecionado || !id) {
                        alert(MENSAGENS.PREENCHIMENTO_OBRIGATORIO);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    formData = new FormData();
                    formData.append('nome', nomeArquivo);
                    formData.append('nome_original', arquivoSelecionado.name);
                    formData.append(tipoIdField, tipoSelecionado.toString());
                    formData.append('arquivo', arquivoSelecionado);
                    return [4 /*yield*/, services.cadastrarItem(formData, id)];
                case 1:
                    resp = _b.sent();
                    if (resp.Status !== 'ERRO') {
                        setDocumentos(resp[listaDocumentosField] || ((_a = resp.dados) === null || _a === void 0 ? void 0 : _a[listaDocumentosField]) || []);
                        setNomeArquivo('');
                        setTipoSelecionado(-1);
                        setArquivoSelecionado(null);
                        setNomeArquivoOriginal('');
                    }
                    else {
                        alert(resp.Mensagem);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var salvarEdicao = function () { return __awaiter(void 0, void 0, void 0, function () {
        var dados, resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!editarDados.nome || editarDados.tipoId === -1)
                        return [2 /*return*/];
                    setLoading(true);
                    dados = (_a = { nome: editarDados.nome }, _a[tipoIdField] = editarDados.tipoId, _a);
                    return [4 /*yield*/, services.alterarItem(dados, editarDados.id.toString())];
                case 1:
                    resp = _b.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        setDocumentos(function (prev) { return prev.map(function (doc) { return (doc.id === editarDados.id ? __assign(__assign({}, doc), dados) : doc); }); });
                        setPopupAberto(false);
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem(MENSAGENS.REGISTRO_ALTERADO_SUCESSO);
                    }
                    else {
                        alert((resp === null || resp === void 0 ? void 0 : resp.Mensagem) || 'Erro ao salvar');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var excluirDocumento = function (docId) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, services.excluirItem(docId)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        setDocumentos(function (prev) { return prev.filter(function (doc) { return doc.id !== +docId; }); });
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem(MENSAGENS.REGISTRO_EXCLUIDO_SUCESSO);
                    }
                    else {
                        alert((resp === null || resp === void 0 ? void 0 : resp.Mensagem) || 'Erro ao excluir');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleViewFile = function (arquivo, docId) {
        var bytes = extrairBytesPdf(arquivo);
        if (!bytes || !isPdfValido(bytes)) {
            window.open(services.getVisualizacaoURL(docId.toString()), '_blank');
            return;
        }
        var blob = new Blob([bytes], { type: 'application/pdf' });
        window.open(URL.createObjectURL(blob), '_blank');
    };
    var handleDownload = function (docId, nomeOrig) { return __awaiter(void 0, void 0, void 0, function () {
        var resp, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!services.baixarItem)
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, services.baixarItem(docId.toString())];
                case 1:
                    resp = _a.sent();
                    if (resp.Status !== 'ERRO') {
                        link = document.createElement('a');
                        link.href = URL.createObjectURL(resp.dados || resp);
                        link.download = nomeOrig || 'documento.pdf';
                        link.click();
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var colunas = [
        { field: 'nome', headerName: 'Nome do Arquivo', width: 300 },
        {
            field: tipoIdField,
            headerName: 'Tipo de Documento',
            width: 300,
            valueGetter: function (_v, row) { var _a; return (_a = tiposDisponiveis.find(function (t) { return t.id == row[tipoIdField]; })) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        { field: 'nome_original', headerName: 'Arquivo', width: 300 },
        { field: 'created_at', headerName: 'Data de Envio', width: 150, valueGetter: function (_v, row) { return getDataFormatada(row.created_at); } },
        {
            field: 'acoes',
            headerName: '',
            align: 'right',
            flex: 1,
            renderCell: function (params) { return (_jsxs(Box, __assign({ display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(IconButton, __assign({ size: 'small', onClick: function () { return handleViewFile(params.row.arquivo, params.row.id); }, disabled: !acoesFuncionalidade['VISUALIZAR'] }, { children: _jsx(VisibilityOutlinedIcon, { fontSize: 'small' }) })), services.baixarItem && (_jsx(IconButton, __assign({ size: 'small', onClick: function () { return handleDownload(params.row.id, params.row.nome_original); }, disabled: !acoesFuncionalidade['VISUALIZAR'] }, { children: _jsx(DownloadIcon, { fontSize: 'small' }) }))), _jsx(IconButton, __assign({ size: 'small', onClick: function () {
                            setEditarDados({ id: params.row.id, nome: params.row.nome, tipoId: params.row[tipoIdField], nomeOriginal: params.row.nome_original });
                            setPopupAberto(true);
                        }, disabled: desabilitarCampos || !acoesFuncionalidade['ALTERAR'] }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'small' }) })), _jsx(IconButton, __assign({ size: 'small', onClick: function () { return excluirDocumento(params.row.id.toString()); }, disabled: desabilitarCampos || !acoesFuncionalidade['EXCLUIR'] }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'small' }) }))] }))); },
        },
    ];
    return (_jsxs(Box, __assign({ mt: 3 }, { children: [titulo && _jsx(Typography, __assign({ variant: 'h6' }, { children: titulo })), _jsxs(Grid, __assign({ container: true, spacing: 2, mt: 1 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { label: 'Nome do Arquivo', value: nomeArquivo, onChange: function (e) { return setNomeArquivo(e.target.value); }, disabled: desabilitarCampos, required: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsxs(InputDados, __assign({ select: true, label: 'Tipo de Documento', value: tipoSelecionado, onChange: function (e) { return setTipoSelecionado(e.target.value); }, disabled: desabilitarCampos, required: true }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), tiposDisponiveis.map(function (t) { return (_jsx(MenuItem, __assign({ value: t.id }, { children: t.nome }), t.id)); })] })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: [_jsxs(BotaoAuxiliar, __assign({ component: 'label', backgroundColor: 'terceary.main', disabled: desabilitarCampos }, { children: ["Selecionar Arquivo", _jsx("input", { type: 'file', accept: 'application/pdf', hidden: true, onChange: handleFileChange, disabled: desabilitarCampos })] })), nomeArquivoOriginal && (_jsx(Typography, __assign({ variant: 'caption', display: 'block' }, { children: nomeArquivoOriginal })))] })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsxs(BoxBotoes, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: function () {
                                        setNomeArquivo('');
                                        setTipoSelecionado(-1);
                                        setArquivoSelecionado(null);
                                        setNomeArquivoOriginal('');
                                    }, backgroundColor: 'error.main', disabled: desabilitarCampos }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ onClick: adicionarDocumento, backgroundColor: 'principal.main', disabled: desabilitarCampos || !acoesFuncionalidade['CADASTRAR'] }, { children: "Adicionar" }))] }) }))] })), _jsx(Box, __assign({ mt: 4 }, { children: _jsx(GridComp, { rows: documentos, columns: colunas, loading: loading }) })), _jsxs(BoxBotoes, __assign({ sx: { mt: 4 } }, { children: [setAbaAtiva && (_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(abaVoltar !== null && abaVoltar !== void 0 ? abaVoltar : 0); } }, { children: "Voltar" }))), fluxoCadastro && setAbaAtiva ? (_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'principal.main', onClick: function () { return setAbaAtiva((abaVoltar !== null && abaVoltar !== void 0 ? abaVoltar : 0) + 2); } }, { children: "Avan\u00E7ar" }))) : (_jsx(BotaoFechar, { modo: modo, pagina: rotaVoltar }))] })), _jsxs(Dialog, __assign({ open: popupAberto, onClose: function () { return setPopupAberto(false); }, fullWidth: true, maxWidth: 'sm' }, { children: [_jsx(DialogTitle, { children: "Editar Documento" }), _jsxs(DialogContent, { children: [_jsx(Box, __assign({ mt: 2 }, { children: _jsx(InputDados, { label: 'ID', value: editarDados.id, disabled: true }) })), _jsx(Box, __assign({ mt: 2 }, { children: _jsx(InputDados, { label: 'Nome do Arquivo', value: editarDados.nome, onChange: function (e) { return setEditarDados(__assign(__assign({}, editarDados), { nome: e.target.value })); }, required: true }) })), _jsx(Box, __assign({ mt: 2 }, { children: _jsxs(InputDados, __assign({ select: true, label: 'Tipo de Documento', value: editarDados.tipoId, onChange: function (e) { return setEditarDados(__assign(__assign({}, editarDados), { tipoId: e.target.value })); }, required: true }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), tiposDisponiveis.map(function (t) { return (_jsx(MenuItem, __assign({ value: t.id }, { children: t.nome }), t.id)); })] })) })), _jsx(Box, __assign({ mt: 2 }, { children: _jsx(InputDados, { label: 'Arquivo', value: editarDados.nomeOriginal, disabled: true }) }))] }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return setPopupAberto(false); } }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: salvarEdicao, variant: 'contained' }, { children: "Salvar" }))] })] })), loading && _jsx(Loading, {})] })));
};
